import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { apiConfig } from 'src/app/api.config';
import { environment } from 'src/environments/environment';
import { IArrayResponse } from '../common/models/general.model';
import { Challenge } from '../common/models/master-data/challenge';

@Injectable({
  providedIn: 'root',
})
export class SelectChallengeService {
  #http = inject(HttpClient);
  private apiUrl = environment.api;

  getChallenges() {
    return this.#http
      .get<
        IArrayResponse<Challenge>
      >(this.apiUrl + apiConfig.masterData.getChallenges)
      .pipe(map((res) => res.results));
  }

  getChallengesByPSL(pslId: string) {
    return this.#http
      .get<
        IArrayResponse<Challenge>
      >(this.apiUrl + apiConfig.masterData.getChallengesByPSL.replace(':id', pslId))
      .pipe(map((res) => res.results));
  }

  getChallengesByPSLCode(pslCode: string) {
    return this.#http
      .get<
        IArrayResponse<Challenge>
      >(this.apiUrl + apiConfig.masterData.getChallengesByPSLCode.replace(':code', pslCode))
      .pipe(map((res) => res.results));
  }
}
